import { render, staticRenderFns } from "./MyActions.vue?vue&type=template&id=2bf5edfe&scoped=true&"
import script from "./MyActions.vue?vue&type=script&lang=js&"
export * from "./MyActions.vue?vue&type=script&lang=js&"
import style0 from "./MyActions.vue?vue&type=style&index=0&id=2bf5edfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5edfe",
  null
  
)

export default component.exports